import React, {
    Component,
    Fragment,
} from 'react';

import { connect } from 'react-redux';

import NotFound from 'wanderu-component-not-found';
import { BusLoader } from 'wanderu-components';
import { i18nCoordinator } from 'wanderu-i18n';

import TermsAndConditions from '../../components/TermsAndConditions/TermsAndConditions';
import TermsAndConditionsMeta from '../../components/TermsAndConditionsMeta/TermsAndConditionsMeta';
import tcConfig from '../../config/termsandconditions.locale';
import {
    fetchTCContentAction,
    termsAndConditionsSelectors,
} from '../../ducks';
import {
    getTranslations,
} from '../../services';

class TermsAndConditionsContainer extends Component {
    static async serverFetchData(opts) {
        const {
            dispatch,
            params,
            i18nCoordinator,
        } = opts;

        await Promise.all([
            i18nCoordinator.registerTranslatableApp({
                ...tcConfig,
                translationFetchFn: async (locale) => {
                    return getTranslations(locale, params.policy);
                },
            }),
            dispatch(fetchTCContentAction.fetchTCContent(params)),
        ]);
    }

    async componentDidMount() {
        const {
            match,
            isLoaded,
            isFetching,
        } = this.props;
        const {
            params,
        } = match;

        if (!isLoaded && !isFetching) {
            this.props.fetchContent(params);
        }

        await i18nCoordinator.registerTranslatableApp({
            ...tcConfig,
            translationFetchFn: async (locale) => {
                return getTranslations(locale, this.props.match.params.policy);
            },
        });
    }

    componentDidUpdate(prevProps) {
        const {
            match,
        } = this.props;
        const {
            locale,
            policy,
        } = match.params;
        const {
            locale: prevLocale,
            policy: prevPolicy,
        } = prevProps.match.params;

        if (locale !== prevLocale || policy !== prevPolicy) {
            this.props.fetchContent(match.params);
        }

        if (policy !== prevPolicy) {
            i18nCoordinator.refetchTranslations(tcConfig.namespace);
        }
    }

    componentWillUnmount() {
        i18nCoordinator.unregisterTranslatableApp(tcConfig.namespace);
    }

    render() {
        const {
            content,
            hasError,
            isFetching,
            isLoaded,
            staticContext,
        } = this.props;

        if (staticContext) {
            staticContext.cache = {
                secondsFromNow: 60 * 60 * 24 * 7,
            };

            if (hasError) {
                staticContext.status = hasError.status;
                staticContext.cache = undefined;
            }
        }

        const isLoading = isFetching || !isLoaded;

        return (
            <Fragment>
                <TermsAndConditionsMeta />
                {content && (
                    <TermsAndConditions
                        intro={content.intro}
                        sections={content.sections}
                        shortcuts={content.shortcuts}
                    />
                )}
                {hasError && (
                    <NotFound />
                )}
                {isLoading && !hasError && (
                    <BusLoader large />
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(appState, ownProps) {
    const {
        match,
    } = ownProps;
    const {
        params,
    } = match;

    return {
        locale: params.locale,
        content: termsAndConditionsSelectors.selectTCContent(appState, params),
        isFetching: fetchTCContentAction.selectWorking(appState, params),
        isLoaded: fetchTCContentAction.selectSuccess(appState, params),
        hasError: fetchTCContentAction.selectError(appState, params),
    };
}

const mapDispatchToProps = {
    fetchContent: fetchTCContentAction.fetchTCContent,
};

export {
    TermsAndConditionsContainer,
    mapStateToProps,
};
export default connect(mapStateToProps, mapDispatchToProps)(
    TermsAndConditionsContainer,
    tcConfig.namespace,
);
